import { V3CoverSlide } from "./slides/V3CoverSlide";
import { V3OverviewSlide } from "./slides/V3OverviewSlide";
import { V3ProblemSlide } from "./slides/V3ProblemSlide";
import { V3WhatWeDoSlide } from "./slides/V3WhatWeDoSlide";
import { V3ProductsSlide } from "./slides/V3ProductsSlide";
import { V3PartnersSlide } from "./slides/V3PartnersSlide";
import { V3HowWeEarnSlide } from "./slides/V3HowWeEarnSlide";
import { V3VerticalsSlide } from "./slides/V3VerticalsSlide";
import { V3MarketSlide } from "./slides/V3MarketSlide";
import { V3CompetitionSlide } from "./slides/V3CompetitionSlide";
import { V3HowItScalesSlide } from "./slides/V3HowItScalesSlide";
import { V3TeamSlide } from "./slides/V3TeamSlide";
import { V3TheAskSlide } from "./slides/V3TheAskSlide";
import { V3CloseSlide } from "./slides/V3CloseSlide";

export const investorV3SlideComponents = [
  V3CoverSlide,
  V3OverviewSlide,
  V3ProblemSlide,
  V3WhatWeDoSlide,
  V3ProductsSlide,
  V3PartnersSlide,
  V3HowWeEarnSlide,
  V3VerticalsSlide,
  V3MarketSlide,
  V3CompetitionSlide,
  V3HowItScalesSlide,
  V3TeamSlide,
  V3TheAskSlide,
  V3CloseSlide,
];
